export const OPEN_TELEMETRY_TRACES_URL = 'https://ot.ezlo.com/traces';
export const OPEN_TELEMETRY_LOGS_URL = 'https://ot.ezlo.com/logs';
